import {Injectable} from "@angular/core";
import featureFlags from "../../config/feature-flags.json";

interface FeatureFlags {
  [key: string]: boolean;
}

@Injectable({providedIn: 'root'})
export class FeatureFlagsService {
  private readonly featureFlags = featureFlags as FeatureFlags;

  constructor() {
  }

  getFeatureFlags(): FeatureFlags {
    return this.featureFlags;
  }

  getFeatureFlag(key: string): boolean {
    if (!this.featureFlags || !key) {
      return false;
    }

    return this.featureFlags[key] ?? false;
  }
}
